import type { SuperPlayer } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';

export interface INoteViewMediaSyncManager {
    initServiceProxy: (serviceProxy) => void;
    attachMediaEvent: (mediaInstance, mediaId: string, playerType: PlayerType) => void;
    syncVideoState: (mediaInfo: IMediaSyncInfo) => void;
    handleMediaCmd: (mediaIns: SuperPlayer | null, mediaInfo: IMediaSyncInfo, pictureModelKey: string) => void;
    destroy: () => void;
}

export interface INoteViewMediaSyncManagerInjectable {
    attachMediaEvent: (mediaInstance, mediaId: string, playerType: PlayerType) => boolean;
}


export enum MediaCmd {
    PLAY = 'play',
    PAUSE = 'pause',
    SPEED = 'speed',
}

export enum PlayerType {
    DESKTOP = 'desktop',
    WEB = 'web',
}

export interface IMediaSyncInfo {
    mediaId: string;
    cmd: MediaCmd,
    playtime: number; // 播放时间
    speed?: number; // 播放速度
}
